module.exports = __webpack_public_path__ + "img/GTF5.6dccb443.png";